module.exports = __webpack_public_path__ + "static/media/spm.91179997.webp";